import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { useQuery } from "@tanstack/react-query";

export const useGetCarbSwaps = () => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.CARB_OPTIONS],
    staleTime: QueryStaleTime.MEDIUM,
    queryFn: async () => {
      const { data } = await MealsService.getCarbSwapsApiV1MealsCarbSwapsGet();
      return data ?? [];
    },
  });

  return { carbSwaps: data, isLoading, isError, error, refetch };
};
